import React, { useEffect, useRef } from 'react';
import './Mission.css';

const Mission = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible'); 
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = sectionRef.current.querySelectorAll('.animate-item');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="mission-section" ref={sectionRef}>
      <div className="mission-wrapper">
        <div className="mission-header animate-item">
          <span className="sub-tag">Our Philosophy</span>
          <h2>Our <span>Mission & Values</span></h2>
          <div className="fancy-line"></div>
        </div>

        <div className="mission-grid">
          {/* Card 1 */}
          <div className="mission-card animate-item delay-1">
            <div className="card-bg-overlay"></div>
            <div className="card-content">
              <div className="icon-box">🎯</div>
              <h3>Our Mission</h3>
              <p>To make <strong>high-quality healthcare</strong> accessible at every doorstep across India.</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="mission-card animate-item delay-2">
            <div className="card-bg-overlay"></div>
            <div className="card-content">
              <div className="icon-box">👁️</div>
              <h3>Our Vision</h3>
              <p>To revolutionize <strong>patient care</strong> through convenience, technology, and empathy.</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="mission-card animate-item delay-3">
            <div className="card-bg-overlay"></div>
            <div className="card-content">
              <div className="icon-box">🤝</div>
              <h3>Our Values</h3>
              <p><strong>Empathy, Transparency, Trust, and Innovation</strong> in everything we do.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;